/**
 * Store for SpecialPages
 */

import { doFetch } from '../../utils/CommonUtils';
import Routes from '../../utils/Routes';
import FluxEventEmitter from '../FluxEventEmitter';
import assign from 'object-assign';
import Constants from '../Constants.js';

const CHANGE_EVENTS = {
	GamePoints: 'gamePoints',
	Reward: 'rewardChange',
	RewardHistory: 'rewardHistoryChange',
	SpecialEventData: 'specialEventDataChange',
	Tries: 'triesChange',
	EasterNotification: 'easterNotification',
	showLoader: 'showLoader',
};

let _reward = null;
let _rewardHistory = [];
const _specialEventData = {};
const _tries = {
	available: 0,
	total: 0,
	used: 0,
};

let _loaderType = '';

const SpecialStore = assign({}, FluxEventEmitter.prototype, {
	EVENTS: CHANGE_EVENTS,

	addShowLoaderChangeListener: function (callback) {
		this.on(CHANGE_EVENTS.showLoader, () => callback(_loaderType));
	},

	removeShowLoaderChangeListener: function (callback) {
		this.removeListener(CHANGE_EVENTS.showLoader, () => callback(_loaderType));
	},

	getReward: function () {
		return _reward;
	},

	getRewardHistory: function () {
		return _rewardHistory;
	},

	getSpecialEventData: function (eventType) {
		let eventData = null;
		if (typeof _specialEventData[eventType] !== 'undefined') {
			eventData = _specialEventData[eventType];
		}

		return eventData;
	},

	getTriesAvailable: function () {
		return _tries.available;
	},

	// Action methods
	loadSpecialEventData: function (eventType, qmDate) {
		let route = Routes.getRoute(Routes.Names.SPECIAL_EVENT_DATA, { eventType: eventType });
		if (qmDate) {
			route += '&qmdate=' + qmDate;
		}

		doFetch(route, null, Constants.HttpMethods.GET, true).then((result) => {
			if (result) {
				_specialEventData[eventType] = result.data;
				SpecialStore.emit(CHANGE_EVENTS.SpecialEventData, eventType);
			}
		});
	},

	setActorOnlineState: function (actorId, state) {
		if (_specialEventData[Constants.SpecialEvents.SPECIAL_VR_PORN]) {
			const vrPornData = _specialEventData[Constants.SpecialEvents.SPECIAL_VR_PORN];
			for (const a in vrPornData.actors) {
				if (Object.hasOwn(vrPornData.actors, a) && vrPornData.actors[a].id === actorId) {
					vrPornData.actors[a].isOnline = state;
					SpecialStore.emit(CHANGE_EVENTS.SpecialEventData, Constants.SpecialEvents.SPECIAL_VR_PORN);
					break;
				}
			}
		}
	},

	setLastOnTopInactiveByCode: function (code) {
		for (let r = _rewardHistory.length - 1; r >= 0; r--) {
			if (_rewardHistory[r].optionCode === code && _rewardHistory[r].canRedeem) {
				_rewardHistory[r].canRedeem = false;
				break;
			}
		}

		SpecialStore.emit(CHANGE_EVENTS.RewardHistory);
	},

	setReward: function (reward) {
		_reward = reward;
		SpecialStore.emit(CHANGE_EVENTS.Reward);
	},

	setRewardHistory: function (rewardHistory) {
		_rewardHistory = rewardHistory;
		SpecialStore.emit(CHANGE_EVENTS.RewardHistory);
	},

	setTries: function (available, total) {
		_tries.available = available;
		_tries.total = total;
		_tries.used = total - available;
		SpecialStore.emit(CHANGE_EVENTS.Tries);
	},

	collectEgg: function (verificationToken, qmDate) {
		doFetch(Routes.getRoute(Routes.Names.EASTER_COLLECT_EGG), { verificationToken, qmdate: qmDate }, Constants.HttpMethods.POST, true).then(
			() => {
				SpecialStore.emit(CHANGE_EVENTS.EasterNotification);
			},
		);
	},

	loadHalloweenReward: function (qmDate, eventId) {
		let route = Routes.getRoute(Routes.Names.HALLOWEEN_GET_REWARD, { eventId }, null);

		if (qmDate) {
			route += '&qmdate=' + qmDate;
		}
		doFetch(route, null, Constants.HttpMethods.GET, true)
			.then(
				function (result) {
					if (result.success) {
						const data = result.data.data;

						if (data.reward) {
							SpecialStore.setReward(data.reward);
						}

						if (data.guestData) {
							SpecialStore.setRewardHistory(data.guestData.rewardHistory);
						}
					} else {
						throw new Error();
					}
				}.bind(this),
			)
			.catch(function () {});
	},

	loadWiesnShootingReward: function (qmDate) {
		const route = Routes.getRoute(Routes.Names.WIESN_SHOOTING_GET_REWARD, { eventId: 22 }, null);

		doFetch(route, { qmdate: qmDate }, Constants.HttpMethods.GET, true)
			.then(
				function (result) {
					if (result.success) {
						const data = result.data.data;

						if (data.guestData) {
							SpecialStore.setRewardHistory(data.guestData.rewardHistory);
							SpecialStore.setTries(data.guestData.creditsAvailable, data.guestData.creditsTotal);
						}

						if (data.reward) {
							SpecialStore.setReward(data.reward);
						}
					} else {
						throw new Error();
					}
				}.bind(this),
			)
			.catch(function () {});
	},

	loadWetAndWildReward: function (eventId, qmDate) {
		const route = Routes.getRoute(Routes.Names.WET_AND_WILD_GET_REWARD, { eventId }, null);

		doFetch(route, { qmdate: qmDate }, Constants.HttpMethods.GET, true)
			.then(
				function (result) {
					if (result.success) {
						const data = result.data.data;

						if (data.guestData) {
							SpecialStore.setRewardHistory(data.guestData.rewardHistory);
							SpecialStore.setTries(data.guestData.creditsAvailable, data.guestData.creditsTotal);
						}

						if (data.reward) {
							SpecialStore.setReward(data.reward);
						}
					} else {
						throw new Error();
					}
				}.bind(this),
			)
			.catch(function () {});
	},

	loadWiesnBudeReward: function (qmDate) {
		const route = Routes.getRoute(Routes.Names.WIESN_BUDE_GET_REWARD, { eventId: 30 }, null);

		doFetch(route, { qmdate: qmDate }, Constants.HttpMethods.GET, true)
			.then(
				function (result) {
					if (result.success) {
						const data = result.data.data;

						if (data.guestData) {
							SpecialStore.setRewardHistory(data.guestData.rewardHistory);
							SpecialStore.setTries(data.guestData.creditsAvailable, data.guestData.creditsTotal);
						}

						if (data.reward) {
							SpecialStore.setReward(data.reward);
						}
					} else {
						throw new Error();
					}
				}.bind(this),
			)
			.catch(function () {});
	},

	showLoader: function (type) {
		_loaderType = type;
		SpecialStore.emit(CHANGE_EVENTS.showLoader, type);
	},

	hideLoader: function () {
		_loaderType = 'none';
		SpecialStore.emit(CHANGE_EVENTS.showLoader, 'none');
	},
});

export default SpecialStore;
